<div
	class="p-m bg-[#efeef8] rounded-sm white-text"
	fxLayout="row"
	fxLayoutAlign="space-between center"
>
	<div class="dark-grey-texts" i18n="@@notification_banner_stripe">
		For receiving or giving donation, verify your account with Stripe
	</div>
	<div fxLayoutAlign="space-between center">
		<button
			mat-flat-button
			color="accent"
			(click)="verifyWithStripeEmbeddedAccountOnboard()"
		>
			<span i18n="@@payout_settings_verify_with_stripe_button" class="nowrap"
				>Verify With Stripe</span
			>
			<mat-icon *ngIf="isLoading" class="m-l-xs">
				<mat-spinner color="primary" diameter="16"> </mat-spinner>
			</mat-icon>
		</button>
	</div>
</div>
